class AbstractStorage {
  store;
  constructor(store) {
    this.store = store;
  }
}
export {
  AbstractStorage
};
//# sourceMappingURL=AbstractStorage.js.map
